(() => {
  const tidy = value => (value || '').replace(/\s+/g, ' ').trim();
  const postcodeSummary = 'View Complete List of Undeliverable Postcode Suburb Combinations';
  const returnPolicy = 'COM (change of mind) Return Policy: The product must be unopened and in brand new condition, with the return to be organised by the customer. Once received and verified to be in the condition specified, refund is only of the item value minus 15% restocking fee (not including initial shipping). An additional return charge, which is same cost as that of initial shipping, will be deducted from the refund on returns due to delivery failure caused by customer error. For the health and safety of our staff and other customers, we are unable to accept returns of personal use items.';
  const hide = element => {
    element.classList.add('hmg-supplier-postcodes-hidden');
    element.hidden = true;
    element.style.setProperty('display', 'none', 'important');
  };
  function removeReturnPolicy(description) {
    if (!/COM\s*\(\s*change\s+of\s+mind\s*\)\s*Return\s+Policy\s*:/i.test(description.textContent)) return;
    const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT, {
      acceptNode: node => node.parentElement?.closest('script, style, template') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    });
    const positions = [];
    let text = '';
    while (walker.nextNode()) {
      const node = walker.currentNode;
      for (let offset = 0; offset < node.data.length; offset++) {
        const char = node.data[offset];
        if (/\s/.test(char)) {
          if (text && !text.endsWith(' ')) {
            text += ' ';
            positions.push({ node, offset });
          }
        } else {
          text += char;
          positions.push({ node, offset });
        }
      }
      if (text && !text.endsWith(' ')) {
        text += ' ';
        positions.push({ node, offset: node.data.length });
      }
    }
    let start = text.toLowerCase().indexOf(returnPolicy.toLowerCase());
    if (start < 0) return;
    const end = start + returnPolicy.length;
    const prefix = text.slice(0, start);
    const note = /Note:\s*$/i.exec(prefix);
    if (note) {
      const position = positions[note.index];
      const before = position.node.data.slice(0, position.offset);
      if (!tidy(before)) start = note.index;
    }
    const first = positions[start];
    const last = positions[end - 1];
    const ancestors = new Set();
    for (const endpoint of [first, last]) {
      for (let parent = endpoint.node.parentElement; parent && parent !== description; parent = parent.parentElement) ancestors.add(parent);
    }
    const range = document.createRange();
    range.setStart(first.node, first.offset);
    range.setEnd(last.node, last.offset + 1);
    range.deleteContents();
    [...ancestors].forEach(element => {
      if (!tidy(element.textContent) && !element.querySelector('img, video, audio, iframe, input, button, a, svg')) element.remove();
    });
    removeReturnPolicy(description);
  }
  function update(root) {
    const descriptions = [...root.querySelectorAll('.product__description')];
    if (root.matches?.('.product__description')) descriptions.unshift(root);
    descriptions.forEach(description => {
      description.querySelectorAll('details').forEach(details => {
        const summary = details.querySelector(':scope > summary');
        if (tidy(summary?.textContent) === postcodeSummary) hide(details);
      });
      description.querySelectorAll('strong, b, h2, h3, h4').forEach(heading => {
        if (tidy(heading.textContent) !== 'Shipping Restriction Notice') return;
        const notice = heading.parentElement;
        const message = notice.querySelector(':scope > p');
        if (notice.tagName !== 'DIV' || !message || notice.children.length !== 2) return;
        if (!tidy(message.textContent).startsWith('Shipments to the specific postcode-suburb combinations below are excluded.')) return;
        hide(notice);
        const wrapper = notice.parentElement;
        if (wrapper !== description && wrapper.tagName === 'DIV' && wrapper.children.length === 1 && tidy(wrapper.textContent) === tidy(notice.textContent)) hide(wrapper);
      });
      description.querySelectorAll('p').forEach(paragraph => {
        const text = tidy(paragraph.textContent);
        const prefix = 'Delivery excludes the following postcodes:';
        if (text.startsWith(prefix) && /^[\d\s,;–—-]+$/.test(text.slice(prefix.length)) && !paragraph.querySelector('img, a, video, iframe')) hide(paragraph);
      });
      removeReturnPolicy(description);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => update(document));
  else update(document);
  document.addEventListener('shopify:section:load', event => update(event.target));
})();
